import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { NAV_ITEMS } from '@/mocks';

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-950/95 backdrop-blur-md shadow-[0_1px_0_0_rgba(255,255,255,0.06)]'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6" aria-label="主导航">
        <div className="max-w-[1440px] mx-auto flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap group"
            aria-label="777影院首页"
          >
            <span className="text-2xl font-heading font-bold text-primary-500 tracking-tight group-hover:text-primary-400 transition-colors">
              777
            </span>
            <span className="text-lg font-heading font-semibold text-foreground-100">
              影院
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {NAV_ITEMS.map((item) => {
              const isActive = location.pathname === item.href
                || (item.href !== '/' && location.pathname.startsWith(item.href));
              return (
                <Link
                  key={item.href}
                  to={item.href}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                    isActive
                      ? 'bg-primary-500/15 text-primary-500'
                      : 'text-foreground-400 hover:text-foreground-100 hover:bg-background-700/50'
                  }`}
                >
                  {item.label}
                </Link>
              );
            })}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索影视..."
                className="bg-background-800 border border-background-600 rounded-full px-4 py-2 pl-10 text-sm text-foreground-200 placeholder-foreground-500 focus:outline-none focus:border-primary-500/50 focus:ring-1 focus:ring-primary-500/30 w-48 transition-all"
                aria-label="搜索影视内容"
              />
              <i className="ri-search-line absolute left-3.5 top-1/2 -translate-y-1/2 text-foreground-500 text-sm"></i>
            </div>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-200 hover:text-foreground-100"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="切换菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-background-950 border-t border-background-700">
            <div className="px-4 py-3 flex flex-col gap-1">
              {NAV_ITEMS.map((item) => {
                const isActive = location.pathname === item.href
                  || (item.href !== '/' && location.pathname.startsWith(item.href));
                return (
                  <Link
                    key={item.href}
                    to={item.href}
                    onClick={() => setMobileOpen(false)}
                    className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                      isActive
                        ? 'bg-primary-500/15 text-primary-500'
                        : 'text-foreground-400 hover:text-foreground-100'
                    }`}
                  >
                    {item.label}
                  </Link>
                );
              })}
              <div className="pt-2">
                <div className="relative">
                  <input
                    type="text"
                    placeholder="搜索影视..."
                    className="w-full bg-background-800 border border-background-600 rounded-full px-4 py-2.5 pl-10 text-sm text-foreground-200 placeholder-foreground-500 focus:outline-none focus:border-primary-500/50"
                    aria-label="搜索影视内容"
                  />
                  <i className="ri-search-line absolute left-3.5 top-1/2 -translate-y-1/2 text-foreground-500 text-sm"></i>
                </div>
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}